import Button from '../button';
import {getRestProps} from '../utils';

export default function(obj, _Vdt, blocks, $callee) {
    _Vdt || (_Vdt = Vdt);
    obj || (obj = {});
    blocks || (blocks = {});
    var h = _Vdt.miss.h, hc = _Vdt.miss.hc, hu = _Vdt.miss.hu, widgets = this && this.widgets || {}, _blocks = {}, __blocks = {},
        __u = _Vdt.utils, extend = __u.extend, _e = __u.error, _className = __u.className, __slice = __u.slice, __noop = __u.noop,
        __m = __u.map, __o = __u.Options, _getModel = __o.getModel, _setModel = __o.setModel,
        _setCheckboxModel = __u.setCheckboxModel, _detectCheckboxChecked = __u.detectCheckboxChecked,
        _setSelectModel = __u.setSelectModel,
        self = this.data, $this = this, scope = obj, Animate = self && self.Animate, parent = ($callee || {})._super;

    const {
    className, children, type,
    disabled, closable, closed, size
} = self.get();

if (closed) return;

const classNameObj = {
    'k-tag': true,
    [className]: className,
    [`k-${type}`]: type !== 'default',
    [`k-${size}`]: size !== 'default',
    'k-disabled': disabled,
    'k-closable': closable,
    [scope.className]: scope.className,
};

    return h(Animate, {
        ...function() {try {return (getRestProps(self) )} catch(e) {_e(e)}}.call($this),
        'a:disabled': function() {try {return (disabled )} catch(e) {_e(e)}}.call($this),
        'a:transition': 'c-fade',
        'className': _className(function() {try {return (classNameObj )} catch(e) {_e(e)}}.call($this)),
        'children': [
            (_blocks['body'] = function(parent) {
                return function() {try {return (children )} catch(e) {_e(e)}}.call($this);
            }) && (__blocks['body'] = function(parent) {
                var args = arguments;
                return blocks['body'] ? blocks['body'].apply($this, [function() {
                    return _blocks['body'].apply($this, args);
                }].concat(__slice.call(args, 1))) : _blocks['body'].apply($this, args);
            }) && __blocks['body'].apply($this, [__noop]),
            function() {try {return (closable )} catch(e) {_e(e)}}.call($this) ?
                h(Button, {
                    'type': 'none',
                    'icon': function() {try {return (!blocks.close )} catch(e) {_e(e)}}.call($this),
                    'className': _className(function() {try {return ({"k-close": true, "k-custom": blocks.close} )} catch(e) {_e(e)}}.call($this)),
                    'disabled': function() {try {return (disabled )} catch(e) {_e(e)}}.call($this),
                    'size': function() {try {return (size )} catch(e) {_e(e)}}.call($this),
                    'children': (_blocks['close'] = function(parent) {
                        return h('i', null, null, 'k-icon ion-ios-close-empty');
                    }) && (__blocks['close'] = function(parent) {
                        var args = arguments;
                        return blocks['close'] ? blocks['close'].apply($this, [function() {
                            return _blocks['close'].apply($this, args);
                        }].concat(__slice.call(args, 1))) : _blocks['close'].apply($this, args);
                    }) && __blocks['close'].apply($this, [__noop]),
                    '_context': $this,
                    'ev-click': function() {try {return (self._close )} catch(e) {_e(e)}}.call($this)
                }) :
                undefined
        ],
        '_context': $this
    })
}